import { render, staticRenderFns } from "./WebsocketWatcher.vue?vue&type=template&id=3530624a&"
import script from "./WebsocketWatcher.vue?vue&type=script&lang=js&"
export * from "./WebsocketWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports